<template>
  <tr>
    <td>
      {{ item.code }}
    </td>
    <td>
      <div class="categories">
        <template v-if="item.categories.length">
          <div v-for="(category, index) in item.categories" :key="index">{{ category.name }}</div>
        </template>
        <span v-else>{{ localStorage.translations.pages.common.text['net-dannyh'] }}</span>
      </div>
    </td>
    <td>
      {{ item.name }}
    </td>
    <td>{{ item.measure }}</td>
    <td>{{  $formatCurrency(item.price) + ' €' }}</td>
    <td>
      <div class="buttons">
        <WorkTypeModal
          v-if="
            $userCheckAccess({
              abilities: 'edit_work_type',
            })
          "
          :create="false"
          :id="item.id"
        />
        <DeleteModal
          v-if="
            $userCheckAccess({
              abilities: 'edit_work_type',
            })
          "
          :item="item"
          :text="
            localStorage.translations.pages['setting-work_type']['dialog-delete'][
              'udalit-vid-raboty'
            ] +
            ' ' +
            item.name
          "
        />
      </div>
    </td>
  </tr>
</template>

<script>
import WorkTypeModal from 'components/setting/workType/WorkTypeModal'
import DeleteModal from 'components/DeleteModal'

export default {
  name: 'WorkTypeTableItem',
  components: { WorkTypeModal, DeleteModal },
  props: ['item'],
}
</script>
